"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iconvLite = require("iconv-lite");
/**
 * Internationalization conversion: convert buffer to requested character encoding
 *
 * @param {string} inCharset The input charset.
 * @param {string} outCharset The output charset.
 * @param {Buffer} buffer The buffer to be converted.
 *
 * @returns {Buffer} the converted buffer or false on failure.
 */
function iconv(inCharset, outCharset, buffer) {
    let str = iconvLite.decode(buffer, inCharset);
    buffer = iconvLite.encode(str, outCharset);
    return buffer;
}
exports.iconv = iconv;
